import React from "react";
import styled from "styled-components";
import { Icon } from ".";
import { DueDiligenceFormStatus } from "../../store/verification/models/internal";
import { colours } from "../../styles/colours";
import { WIDGET_BORDER_RADIUS } from "../widget";

const StyledIcon = styled(Icon)`
  border-radius: ${WIDGET_BORDER_RADIUS};
`;

export const dueDiligenceIconMap: Record<
  typeof DueDiligenceFormStatus["T"],
  React.ReactElement<typeof StyledIcon>
> = {
  DECLINED: (
    <StyledIcon
      colour1={colours.white}
      colour2={colours.red}
      type="dueDiligenceDeclined"
    />
  ),
  PENDING: (
    <StyledIcon
      colour1={colours.white}
      colour2={colours.darkGrey}
      type="dueDiligencePending"
    />
  ),
  PROCESSED: (
    <StyledIcon
      colour1={colours.white}
      colour2={colours.primaryBlue}
      type="dueDiligenceProcessed"
    />
  ),
  SUBMITTED: (
    <StyledIcon
      colour1={colours.black}
      colour2={colours.yellow}
      type="dueDiligenceSubmitted"
    />
  ),
  VERIFIED: (
    <StyledIcon
      colour1={colours.white}
      colour2={colours.green}
      type="dueDiligenceVerified"
    />
  ),
};
